import {
  ConflictKeysType,
  IConflict,
  ProduceJoinConflictsErrorType,
} from "@ryde/shared";

const conflictsErrorsToIncludeStationName = new Set([
  ProduceJoinConflictsErrorType.missingOriginArea,
  ProduceJoinConflictsErrorType.missingDestinationArea,
  ProduceJoinConflictsErrorType.missingOriginStationInfo,
  ProduceJoinConflictsErrorType.missingDestinationStationInfo,
  ProduceJoinConflictsErrorType.invalidStationLocation,
  ProduceJoinConflictsErrorType.stationRouteNotFoundByProvider,
  ProduceJoinConflictsErrorType.stationRouteDurationUnavailable,
  ProduceJoinConflictsErrorType.stationRouteLookupFailed,
]);

export const useConflicts = () => {
  const getConflictsHeaders = (
    groupedConflictsKey: string,
  ): (keyof IConflict)[] => {
    const DEFAULT_HEADER_KEY = [
      ConflictKeysType.bookingId,
      ConflictKeysType.passengerFullName,
      ConflictKeysType.workerCode,
      ConflictKeysType.date,
    ];

    if (
      conflictsErrorsToIncludeStationName.has(
        groupedConflictsKey as ProduceJoinConflictsErrorType,
      )
    ) {
      DEFAULT_HEADER_KEY.splice(1, 0, ConflictKeysType.stationName);
    }

    return DEFAULT_HEADER_KEY as (keyof IConflict)[];
  };

  return {
    getConflictsHeaders,
  };
};
